const setEditMode = (state, payload) => {
  state.isPPTEditMode = payload
}
const setActiveViewMode = (state, payload) => {
  state.addinPPTActiveView = payload
}
export default {
  setEditMode,
  setActiveViewMode,
}
